/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';

/**
 * 
 * @export
 * @interface GameWithPlayTime
 */
export interface GameWithPlayTime {
    /**
     * 
     * @type {OWGameResponse}
     * @memberof GameWithPlayTime
     */
    game?: OWGameResponse;
    /**
     * Total minutes played
     * @type {number}
     * @memberof GameWithPlayTime
     */
    totalTime?: number;
    /**
     * Timestamp of last play session
     * @type {number}
     * @memberof GameWithPlayTime
     */
    lastPlayed?: number;
}

/**
 * Check if a given object implements the GameWithPlayTime interface.
 */
export function instanceOfGameWithPlayTime(value: object): value is GameWithPlayTime {
    return true;
}

export function GameWithPlayTimeFromJSON(json: any): GameWithPlayTime {
    return GameWithPlayTimeFromJSONTyped(json, false);
}

export function GameWithPlayTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameWithPlayTime {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : OWGameResponseFromJSON(json['game']),
        'totalTime': json['totalTime'] == null ? undefined : json['totalTime'],
        'lastPlayed': json['lastPlayed'] == null ? undefined : json['lastPlayed'],
    };
}

export function GameWithPlayTimeToJSON(json: any): GameWithPlayTime {
    return GameWithPlayTimeToJSONTyped(json, false);
}

export function GameWithPlayTimeToJSONTyped(value?: GameWithPlayTime | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': OWGameResponseToJSON(value['game']),
        'totalTime': value['totalTime'],
        'lastPlayed': value['lastPlayed'],
    };
}

